import { BACKEND_KIND, type Backend } from './backend';

export * from './backend';

/** Build the backend selected by VITE_BACKEND. Firebase is dynamically
 *  imported so local/preview builds never load the Firebase SDK. */
export async function createBackend(): Promise<Backend> {
  if (BACKEND_KIND === 'firebase') {
    const { createFirebaseBackend } = await import('./firebaseBackend');
    return createFirebaseBackend();
  }
  const { createLocalBackend } = await import('./localBackend');
  return createLocalBackend();
}
